import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import cn from 'classnames';
import { PlusCircle } from '../../icons';
import { useBiAction } from '../BiTracking';
import { useDevice } from '../Device';
import { Tooltip } from '../Tooltip';
import styles from './AddSlotButton.module.scss';
export function AddSlotButton(props) {
    const { label, icon, onClick, disabled, tooltip, testId, className, bi } = props;
    const { isMobileDevice } = useDevice();
    const hasTooltip = !!(tooltip === null || tooltip === void 0 ? void 0 : tooltip.title);
    const logBiAction = useBiAction();
    const handleClick = useCallback(()=>{
        if (bi === null || bi === void 0 ? void 0 : bi.name) {
            logBiAction({
                entityType: 'button',
                entityName: bi.name,
                actionType: 'click',
                data: _object_spread_props(_object_spread({}, bi.data), {
                    test_id: testId !== null && testId !== void 0 ? testId : ''
                })
            });
        }
        onClick === null || onClick === void 0 ? void 0 : onClick();
    }, [
        bi,
        logBiAction,
        onClick,
        testId
    ]);
    const anchor = /*#__PURE__*/ _jsx("span", {
        className: cn(styles.anchor, {
            [styles.mobile]: isMobileDevice
        }, className),
        "data-testid": testId ? "".concat(testId, "-anchor") : undefined,
        children: /*#__PURE__*/ _jsxs("button", {
            type: "button",
            disabled: disabled,
            onClick: handleClick,
            "data-testid": testId,
            className: styles.root,
            children: [
                icon !== null && icon !== void 0 ? icon : /*#__PURE__*/ _jsx(PlusCircle, {
                    size: 16
                }),
                label
            ]
        })
    });
    return hasTooltip ? /*#__PURE__*/ _jsx(Tooltip, _object_spread_props(_object_spread({}, tooltip), {
        children: anchor
    })) : anchor;
}
